import styles from '../PositionPicker.module.scss';

import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TableInstance } from 'react-table';

import {
  BasicTableColumn,
  CurrencyCell,
  DateCell,
  Table,
  TableStateBagProvider,
} from '@work4all/components';

import { useOpenPartialInvoices } from '../hooks/useOpenPartialInvoices';

type Props = {
  customerId: number;
  onRowDoubleClick: (positionId: number | string) => void;
};

export const PartialInvoicesTable = (props) => {
  const [tableInstance, setTableInstance] = useState<TableInstance | null>(
    null
  );

  return (
    <TableStateBagProvider tableInstance={tableInstance}>
      <PartialInvoicesTableInner ref={setTableInstance} {...props} />
    </TableStateBagProvider>
  );
};

export const PartialInvoicesTableInner = React.forwardRef<TableInstance, Props>(
  function PartialInvoicesTableInner(
    { customerId, onRowDoubleClick }: Props,
    ref
  ) {
    const { t } = useTranslation();
    const columns = useMemo<BasicTableColumn[]>(() => {
      return [
        {
          Header: t('FIELDS.number'),
          accessor: 'number',
          width: 100,
        },
        {
          Header: t('FIELDS.date'),
          accessor: 'date',
          width: 100,
          Cell: DateCell,
        },
        {
          Header: t('COMMON.NOTE'),
          accessor: 'note',
          width: 250,
        },
        {
          Header: t('COMMON.NET'),
          accessor: 'value',
          width: 100,
          Cell: CurrencyCell,
        },
        {
          Header: t('COMMON.GROSS'),
          accessor: 'grossValue',
          width: 100,
          Cell: CurrencyCell,
        },
        {
          Header: t('COMMON.PROJECT'),
          accessor: 'project.name',
          width: 150,
        },
        {
          Header: t('COMMON.PROJECTNUMBER'),
          accessor: 'project.number',
          width: 100,
        },
      ];
    }, [t]);

    const data = useOpenPartialInvoices(customerId);

    return (
      <Table
        ref={ref}
        mode="client"
        draggable
        columns={columns}
        data={data}
        classes={{
          headerRow: styles.background,
          row: styles.background,
          headerCellRoot: styles.background,
          tableBody: styles.background,
          headerWrapper: styles.headerWrapper,
        }}
        onRowDoubleClick={onRowDoubleClick}
        resizableColumns
        reordableColumns
      />
    );
  }
);
